/** CELEX number of an EUR-Lex act: sector digit, year, one or two type letters, four-digit number (e.g. 32004R0852). */
const EUR_LEX_CELEX_PATTERN = /^[0-9]{5}[A-Z]{1,2}[0-9]{4}$/;

/**
 * Whether `value` is a well-formed CELEX number. LLM output is untrusted: a malformed one
 * would build a dead EUR-Lex link, so callers drop the field rather than guess a fix.
 */
export function isEurLexCelex(value: string): boolean {
  return EUR_LEX_CELEX_PATTERN.test(value);
}
